// eslint-disable-next-line import/no-anonymous-default-export
import DiffuseSampler from './diffuse_sampler.glsl'
import MetalnessSampler from './metalness_sampler.glsl'
import RoughnessSampler from './roughness_sampler.glsl'
import EmissiveSampler from './emissive_sampler.glsl'

export default /* glsl */`

${DiffuseSampler}
${MetalnessSampler}
${RoughnessSampler}
${EmissiveSampler}

#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, alphaMapUv ).g;
#endif

`;